<app-central-profile-context kind="team" [name]="!loading && !error ? teamData?.TeamName : ''"></app-central-profile-context>
<main>
  <app-profile-skeleton *ngIf="loading && !error" [name]="previewData?.TeamName" [description]="previewData?.TeamDescription"
    [appearance]="previewData" [resolvedDisplay]="!!previewData?.resolvedDisplay"
    [avatarMediaId]="previewData?.TeamPictureMediaId" [bannerMediaId]="previewData?.TeamBackgroundMediaId"></app-profile-skeleton>
  <dw-message *ngIf="error" [message]="{ messageBody: error, severity: 'error', allowClose: false }"></dw-message>
  <ng-container *ngIf="!loading && !error">
    <ng-container *ngFor="let scope of [formScope]; trackBy: trackFormScope">
    <app-avatar-banner [editable]="canEdit" (styleRequested)="editStyle()" [saveImages]="saveImages" [imageOwnerKey]="'team:' + teamId" mode="full" [resolvedDisplay]="!!displayData" [appearance]="displayData || teamData" [name]="teamData.TeamName" [subtitle]="teamData.TeamLocation"
      [avatarMediaId]="displayData ? displayData.TeamPictureMediaId : teamData.TeamPictureMediaId" [bannerMediaId]="displayData ? displayData.TeamBackgroundMediaId : teamData.TeamBackgroundMediaId">
      <span bannerChips class="captain-badge" *ngIf="isCaptain">★ You’re captain</span>
    </app-avatar-banner>
    <dw-meta-data-form #form item="ChallengeTeam" [keyValue]="teamId"
      [data]="teamData" [overrideData]="true"
      configKeyPart="participant-profile" [preferences]="preferences" [allowConfiguration]="false"
      [showButtons]="false" [handleRedirect]="false"></dw-meta-data-form>

    </ng-container>
  </ng-container>
</main>
